import React from 'react';
import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';

const WidgetCollabo = (props) => {
  //console.log(props);
  const { history } = props;

  const list = props.childProps.payload.list;
  const preText = props.childProps.state.prevMessage;

  const _prev = () => {
    props.childProps.actionProvider._categoryPrev(preText);
  };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };

  const _goItem = (colSerial) => {
    history.push(`/storeCollaboCafe?i=${colSerial}`);
  };
  const _goShop = (shop) => {
    let shopName;
    if (shop === 1) {
      shopName = 'hapjung';
    } else if (shop === 2) {
      shopName = 'daejeon';
    } else if (shop === 3) {
      shopName = 'gwangju';
    } else if (shop === 4) {
      shopName = 'busan';
    }
    history.push(`/storeInfo/${shopName}`);
  };
  return (
    <>
      <div className="scroll-container">
        {list.map((item) => (
          <div className="card">
            <img
              src={
                'https://bc8azosk4j.ecn.cdn.ofs.kr/TShop/collabo/' +
                item.listImg
              }
              alt={item.colTitle}
            />
            <div className="card-content">
              <h3>{item.colTitle}</h3>
              <p>
                {item.startDate}~{item.endDate}
              </p>
              <div className="card-location">
                <div onClick={() => _goShop(1)}>
                  {item.location ? item.location : null}
                </div>
                <div onClick={() => _goShop(4)}>
                  {item.location3 ? item.location3 : null}
                </div>
                <div onClick={() => _goShop(2)}>
                  {item.location1 ? item.location1 : null}
                </div>
                <div onClick={() => _goShop(3)}>
                  {item.location2 ? item.location2 : null}
                </div>
              </div>
              <div
                className="collabo-btn"
                onClick={() => _goItem(item.colSerial)}
              >
                바로가기
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          {preText && (
            <div onClick={_prev} className="prev">
              <img src="/img/chatbot/icon_prev.png" />
              이전 단계로 이동
            </div>
          )}
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};
export default shopContext(withRouter(WidgetCollabo));
